export enum ReminderStatusEnum {
  Pending = 'Pending',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  Hold = 'Hold',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}
